import {combineReducers, Reducer} from '@reduxjs/toolkit'

import {routerReducer} from '@web/slices/router'

import {RootState} from '../../interfaces'
import abTest from '../../slices/abTest'
import aitems from '../../slices/aitems'
import banner from '../../slices/banner'
import common from '../../slices/common'
import deliveryManager from '../../slices/deliveryManager'
import pickup from '../../slices/pickup'
import purchaser from '../../slices/purchaser'
import recommendationProduct from '../../slices/recommendationProduct'
import result from '../../slices/result'
import reward from '../../slices/reward'

const createRootReducer = (): Reducer<RootState> =>
    combineReducers({
        abTest,
        aitems,
        banner,
        common,
        deliveryManager,
        pickup,
        purchaser,
        recommendationProduct,
        result,
        reward,
        router: routerReducer,
    })

export default createRootReducer
